import React from "react";
import Profile from "./Profile";

const SettingsPage = () => {
  return <Profile />;
};

export default SettingsPage;
